function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  id: "defs22"
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: -22.985,
  x2: -22.543,
  y1: -16.726,
  y2: -16.726
}, /*#__PURE__*/React.createElement("stop", {
  id: "stop10",
  stopColor: "#e5e5e6",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  id: "stop12",
  stopColor: "#fff",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: -2806.1,
  x2: -2740.5,
  y1: 867,
  y2: 867,
  gradientTransform: "matrix(1 0 0 1 -170 -2727)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: -2714.4,
  x2: -2648.8,
  y1: 770.32,
  y2: 770.32,
  gradientTransform: "matrix(1 0 0 1 -170 -2727)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "d",
  x1: -2873.8,
  x2: -2808,
  y1: 894.07,
  y2: 894.07,
  gradientTransform: "matrix(1 0 0 1 -170 -2727)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "e",
  x1: -2066.9,
  x2: -2001.3,
  y1: 1776.3,
  y2: 1776.3,
  gradientTransform: "translate(-170,-2727)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "f",
  x1: -2296.8,
  x2: -2231,
  y1: 1969.7,
  y2: 1969.7,
  gradientTransform: "translate(-170,-2727)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "g",
  x1: -2207.9,
  x2: -2142.3,
  y1: 1920.9,
  y2: 1920.9,
  gradientTransform: "translate(-170,-2727)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "h",
  x1: -2130.3,
  x2: -2064.6,
  y1: 1855.7,
  y2: 1855.7,
  gradientTransform: "translate(-170,-2727)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linearGradient350",
  x1: -2800.2,
  x2: -2734.5,
  y1: 823.83,
  y2: 823.83,
  gradientTransform: "matrix(1 0 0 1 -170 -2727)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#a"
}));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  id: "rect24",
  width: 1566,
  height: 800,
  fill: "none"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "path26",
  d: "m1517.2 58.187c-236.87 417.78-720.34 659.54-1218.9 566.58a1158.8 1158.8 0 0 1-285.93-92.741",
  fill: "none",
  stroke: "#2d250c",
  strokeMiterlimit: 10
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "path28",
  d: "m478.7 718.84a74.386 74.386 0 1 1 104.22-14.288 74.385 74.385 0 0 1-104.22 14.288z",
  fill: "url(#linearGradient350)",
  fillRule: "evenodd"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "i2_3"
}, /*#__PURE__*/React.createElement("path", {
  id: "path30",
  d: "m566.4 603.28a70.684 70.684 0 1 1-99.033 13.576 70.765 70.765 0 0 1 99.033-13.576zm-78.207 103.05a58.684 58.684 0 1 0-11.267-82.223 58.752 58.752 0 0 0 11.268 82.223z",
  fill: "#f4c478"
}), /*#__PURE__*/React.createElement("g", {
  id: "g905",
  fill: "#2d250c"
}, /*#__PURE__*/React.createElement("g", {
  id: "g868"
}, /*#__PURE__*/React.createElement("path", {
  id: "path38",
  d: "m525.07 691.95h-26a0.655 0.655 0 0 1-0.656-0.655v-64.169a0.656 0.656 0 0 1 0.656-0.657h47.287a0.656 0.656 0 0 1 0.657 0.657v53.644a0.66 0.66 0 0 1-0.364 0.59l-21.285 10.523a0.67 0.67 0 0 1-0.295 0.067zm-25.346-1.311h25.194l20.783-10.276v-52.582h-45.977z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path40",
  d: "m536.98 648.05h-28.537a0.657 0.657 0 0 1 0-1.313h28.537a0.657 0.657 0 1 1 0 1.313z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path42",
  d: "m524.3 657.92h-15.856a0.6565 0.6565 0 0 1 0-1.313h15.856a0.6565 0.6565 0 1 1 0 1.313z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path44",
  d: "m532.33 667.81h-23.883a0.6565 0.6565 0 0 1 0-1.313h23.883a0.6565 0.6565 0 0 1 0 1.313z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path46",
  d: "m530.49 677.69h-22.043a0.6565 0.6565 0 0 1 0-1.313h22.043a0.6565 0.6565 0 0 1 0 1.313z"
})), /*#__PURE__*/React.createElement("g", {
  id: "g890"
}, /*#__PURE__*/React.createElement("path", {
  id: "path34",
  d: "m520.95 702.86a0.316 0.316 0 0 1-0.053 0l-5.568-0.446a0.657 0.657 0 0 1-0.506-1l3-4.8a0.661 0.661 0 0 1 0.93-0.194 6.639 6.639 0 0 1 2.183 2.515 6.545 6.545 0 0 1 0.668 3.314 0.653 0.653 0 0 1-0.654 0.614zm-4.441-1.67 3.785 0.3a5.273 5.273 0 0 0-0.533-1.979 5.21 5.21 0 0 0-1.211-1.591z"
}), /*#__PURE__*/React.createElement("g", {
  id: "g882"
}, /*#__PURE__*/React.createElement("path", {
  id: "path32",
  d: "m524.95 703.18h-0.053l-9.572-0.774a0.657 0.657 0 0 1-0.5-1l5.133-8.2a0.655 0.655 0 0 1 1.143 0.056l4.443 8.971a0.657 0.657 0 0 1-0.59 0.948zm-8.443-2 7.341 0.593-3.408-6.88z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path36",
  d: "m524.95 703.18h-0.053l-9.572-0.774a0.657 0.657 0 0 1-0.5-1l5.133-8.2a0.631 0.631 0 0 1 0.264-0.24l30.138-14.9a0.654 0.654 0 0 1 0.879 0.3l4.444 8.977a0.663 0.663 0 0 1 0.031 0.5 0.648 0.648 0 0 1-0.33 0.378l-1.063 0.521-29.076 14.377a0.662 0.662 0 0 1-0.295 0.061zm-8.443-2 8.316 0.671 28.914-14.295 0.473-0.232-3.86-7.8-1.087 0.538-28.3 13.993z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path48",
  d: "m538.33 696.57a0.675 0.675 0 0 1-0.271-0.057 0.659 0.659 0 0 1-0.362-0.429l-2.644-9.86a0.656 0.656 0 0 1 0.341-0.757l5.135-2.541a0.655 0.655 0 0 1 0.924 0.418l2.647 9.867a0.653 0.653 0 0 1-0.344 0.757l-5.135 2.535a0.661 0.661 0 0 1-0.291 0.067zm-1.869-10.168 2.3 8.568 3.935-1.942-2.3-8.572z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path50",
  d: "m555.09 688.28a0.653 0.653 0 0 1-0.588-0.364l-4.444-8.978a0.655 0.655 0 0 1 0.3-0.878l2.5-1.235a2.175 2.175 0 0 1 0.973-0.227 2.226 2.226 0 0 1 1.986 1.232l3.065 6.189a2.214 2.214 0 0 1-1 2.959l-2.5 1.234a0.643 0.643 0 0 1-0.292 0.068zm-3.565-9.336 3.86 7.8 1.908-0.941a0.9 0.9 0 0 0 0.453-0.522 0.881 0.881 0 0 0-0.045-0.678l-3.066-6.193a0.9 0.9 0 0 0-0.809-0.5 0.858 0.858 0 0 0-0.391 0.092z"
})))));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "path52",
  d: "m17.291 622.41a74.385 74.385 0 1 1 104.64 10.856 74.384 74.384 0 0 1-104.64-10.856z",
  fill: "url(#b)",
  fillRule: "evenodd"
});

var _ref8 = /*#__PURE__*/React.createElement("g", {
  id: "i2_1",
  fill: "#2d250c"
}, /*#__PURE__*/React.createElement("path", {
  id: "path54",
  d: "m129.91 530.97a70.684 70.684 0 1 1-99.425-10.316 70.764 70.764 0 0 1 99.425 10.316zm-100.43 81.547a58.685 58.685 0 1 0 8.571-82.547 58.753 58.753 0 0 0-8.571 82.547z"
}), /*#__PURE__*/React.createElement("g", {
  id: "g839"
}, /*#__PURE__*/React.createElement("path", {
  id: "path56",
  d: "m62.8 553.61h-19.862a0.6675 0.6675 0 1 1 0-1.335h19.862a0.6675 0.6675 0 1 1 0 1.335z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path58",
  d: "m61.17 560.35h-18.232a0.667 0.667 0 1 1 0-1.334h18.232a0.667 0.667 0 0 1 0 1.334z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path60",
  d: "m55.368 567.08h-12.43a0.6675 0.6675 0 1 1 0-1.335h12.43a0.6675 0.6675 0 0 1 0 1.335z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path62",
  d: "m63.841 575.45a0.67 0.67 0 0 1-0.334-0.089l-5.664-3.269h-20.416a2.974 2.974 0 0 1-2.973-2.971v-19.405a2.974 2.974 0 0 1 2.973-2.97h28.965a2.973 2.973 0 0 1 2.968 2.97v19.405a2.973 2.973 0 0 1-2.968 2.971h-1.887v2.623 0.067a0.669 0.669 0 0 1-0.669 0.668zm-26.414-27.369a1.639 1.639 0 0 0-1.639 1.635v19.405a1.638 1.638 0 0 0 1.639 1.635h20.6a0.645 0.645 0 0 1 0.332 0.091l4.817 2.779v-2.2a0.666 0.666 0 0 1 0.667-0.67h2.555a1.637 1.637 0 0 0 1.634-1.635v-19.405a1.637 1.637 0 0 0-1.634-1.635z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path64",
  d: "m89.558 578.61a14.446 14.446 0 1 1 14.459-14.449 14.47 14.47 0 0 1-14.459 14.449zm0-27.557a13.111 13.111 0 1 0 13.123 13.108 13.13 13.13 0 0 0-13.123-13.108z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path66",
  d: "m111.88 607.09h-44.637a0.667 0.667 0 0 1-0.667-0.667c0-6.625 2.495-12.191 7.216-16.1a25.917 25.917 0 0 1 31.535 0 20.142 20.142 0 0 1 7.217 16.031v0.068a0.668 0.668 0 0 1-0.664 0.668zm-43.961-1.335h43.283c-0.355-13.354-11.383-19.444-21.64-19.444s-21.288 6.093-21.643 19.444z"
})));

var _ref9 = /*#__PURE__*/React.createElement("path", {
  id: "path68",
  d: "m250.65 697.91a74.386 74.386 0 1 1 104.22-14.289 74.385 74.385 0 0 1-104.22 14.289z",
  fill: "url(#c)",
  fillRule: "evenodd"
});

var _ref10 = /*#__PURE__*/React.createElement("g", {
  id: "i2_2"
}, /*#__PURE__*/React.createElement("path", {
  id: "path70",
  d: "m338.35 582.35a70.684 70.684 0 1 1-99.033 13.575 70.761 70.761 0 0 1 99.033-13.575zm-78.208 103.05a58.684 58.684 0 1 0-11.265-82.222 58.753 58.753 0 0 0 11.265 82.222z",
  fill: "#5d752e"
}), /*#__PURE__*/React.createElement("g", {
  id: "g854",
  fill: "#2d250c"
}, /*#__PURE__*/React.createElement("path", {
  id: "path72",
  d: "m280.33 647.24a22.068 22.068 0 1 1 22.066-22.067 22.093 22.093 0 0 1-22.066 22.067zm0-42.865a20.8 20.8 0 1 0 20.8 20.8 20.822 20.822 0 0 0-20.8-20.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path74",
  d: "m263.98 626.65a0.637 0.637 0 0 1-0.638-0.634 18.655 18.655 0 0 1 11.411-17.213 0.63501 0.63501 0 0 1 0.494 1.17 17.387 17.387 0 0 0-10.633 16.043 0.635 0.635 0 0 1-0.634 0.634z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path76",
  d: "m323.67 671.93c-4.087 0-13.182-8.113-18.966-14.326-5.111-5.49-9.285-11.019-11.451-15.17l1.127-0.588c2.084 3.994 6.29 9.562 11.252 14.894 9.6 10.3 17.263 14.976 18.542 13.784s-2.837-9.17-12.431-19.475c-5.286-5.674-10.781-10.593-14.346-12.838l0.677-1.074c3.652 2.3 9.245 7.3 14.6 13.047 6.572 7.058 15.291 18.548 12.368 21.27a1.932 1.932 0 0 1-1.372 0.476z"
})));

var _ref11 = /*#__PURE__*/React.createElement("path", {
  id: "path78",
  d: "m707.77 692.84a74.386 74.386 0 1 1 104.22-14.287 74.383 74.383 0 0 1-104.22 14.287z",
  fill: "url(#d)",
  fillRule: "evenodd"
});

var _ref12 = /*#__PURE__*/React.createElement("g", {
  id: "i2_4"
}, /*#__PURE__*/React.createElement("path", {
  id: "path80",
  d: "m788.18 661.74-14.2-58.455a0.684 0.684 0 0 0-1.33 0l-8.777 36.134-10.5-45.024a0.686 0.686 0 0 0-0.668-0.531 0.688 0.688 0 0 0-0.666 0.537l-10.22 46.155-9.054-37.271a0.685 0.685 0 0 0-1.331 0l-14.2 58.455a0.685 0.685 0 0 0 0.666 0.847h13.516v29.627a0.685 0.685 0 1 0 1.37 0v-29.627h4.155l-0.878 3.967a0.684 0.684 0 0 0 0.669 0.833h15.217v26.869a0.686 0.686 0 1 0 1.369 0v-26.869h16.229a0.686 0.686 0 0 0 0.615-0.988l-0.89-3.812h3.356v29.627a0.685 0.685 0 1 0 1.37 0v-29.627h13.517a0.685 0.685 0 0 0 0.665-0.847zm-69.414-0.523 13.33-54.87 9.046 37.244-3.9 17.626zm18.814 4.8 4.941-22.32 10.2-46.056 15.945 68.377zm31.373-4.8-4.393-18.839 8.752-36.031 13.331 54.87z",
  fill: "#2d250c"
}), /*#__PURE__*/React.createElement("path", {
  id: "path82",
  d: "m795.47 577.27a70.684 70.684 0 1 1-99.033 13.577 70.763 70.763 0 0 1 99.033-13.577zm-78.205 103.05a58.684 58.684 0 1 0-11.268-82.223 58.75 58.75 0 0 0 11.268 82.223z",
  fill: "#fee7a6"
}));

var _ref13 = /*#__PURE__*/React.createElement("path", {
  id: "path84",
  d: "m1492.3 51.578a74.386 74.386 0 1 1-74.385 74.388 74.386 74.386 0 0 1 74.385-74.388z",
  fill: "url(#e)",
  fillRule: "evenodd"
});

var _ref14 = /*#__PURE__*/React.createElement("g", {
  id: "i2_8"
}, /*#__PURE__*/React.createElement("path", {
  id: "path86",
  d: "m1492.3 196.65a70.684 70.684 0 1 1 70.679-70.682 70.763 70.763 0 0 1-70.679 70.682zm0-129.37a58.684 58.684 0 1 0 58.679 58.686 58.751 58.751 0 0 0-58.679-58.686z",
  fill: "#fee7a6"
}), /*#__PURE__*/React.createElement("g", {
  id: "g1080"
}, /*#__PURE__*/React.createElement("path", {
  id: "path88",
  d: "m1516.7 160.1h-52.1a0.634 0.634 0 0 1-0.633-0.633v-66.735a0.633 0.633 0 0 1 0.633-0.631h12.6a0.634 0.634 0 0 1 0.635 0.631v7.8h25.642v-7.8a0.631 0.631 0 0 1 0.632-0.631h12.6a0.634 0.634 0 0 1 0.635 0.631v66.735a0.635 0.635 0 0 1-0.644 0.633zm-51.469-1.266h50.838v-65.469h-11.331v7.8a0.633 0.633 0 0 1-0.633 0.634h-26.909a0.634 0.634 0 0 1-0.633-0.634v-7.8h-11.332z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path90",
  d: "m1512 155.41h-42.709a0.634 0.634 0 0 1-0.634-0.633v-57.347a0.634 0.634 0 0 1 0.634-0.634h7.9a0.635 0.635 0 0 1 0.635 0.634v3.107h25.642v-3.107a0.632 0.632 0 0 1 0.632-0.634h7.9a0.634 0.634 0 0 1 0.633 0.634v57.347a0.634 0.634 0 0 1-0.633 0.633zm-42.076-1.266h41.444v-56.081h-6.636v3.106a0.633 0.633 0 0 1-0.633 0.634h-26.909a0.634 0.634 0 0 1-0.633-0.634v-3.106h-6.633z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path92",
  d: "m1504.1 101.8h-26.909a0.634 0.634 0 0 1-0.633-0.634v-9.658a0.633 0.633 0 0 1 0.633-0.633h3.65v-4.132a0.632 0.632 0 0 1 0.633-0.632h18.345a0.633 0.633 0 0 1 0.632 0.632v4.132h3.649a0.633 0.633 0 0 1 0.633 0.633v9.658a0.633 0.633 0 0 1-0.633 0.634zm-26.274-1.266h25.642v-8.393h-3.649a0.635 0.635 0 0 1-0.634-0.633v-4.131h-17.079v4.131a0.633 0.633 0 0 1-0.632 0.633h-3.648z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path94",
  d: "m1490.7 96.914a3.323 3.323 0 1 1 3.322-3.325 3.327 3.327 0 0 1-3.322 3.325zm0-5.381a2.057 2.057 0 1 0 2.056 2.056 2.06 2.06 0 0 0-2.056-2.056z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path96",
  d: "m1504.3 117.69h-27.289a0.633 0.633 0 1 1 0-1.266h27.289a0.633 0.633 0 1 1 0 1.266z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path98",
  d: "m1484.2 124.08h-7.162a0.634 0.634 0 1 1 0-1.267h7.162a0.634 0.634 0 1 1 0 1.267z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path100",
  d: "m1496.3 130.48h-19.217a0.6325 0.6325 0 1 1 0-1.265h19.217a0.6325 0.6325 0 1 1 0 1.265z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path102",
  d: "m1499.8 136.88h-22.741a0.6335 0.6335 0 1 1 0-1.267h22.741a0.6335 0.6335 0 0 1 0 1.267z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path104",
  d: "m1504.3 143.28h-27.289a0.632 0.632 0 1 1 0-1.264h27.289a0.632 0.632 0 1 1 0 1.264z"
})));

var _ref15 = /*#__PURE__*/React.createElement("path", {
  id: "path106",
  d: "m971.72 489.88a74.385 74.385 0 1 1-74.385 74.387 74.384 74.384 0 0 1 74.385-74.387z",
  fill: "url(#f)",
  fillRule: "evenodd"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  id: "path110",
  d: "m958.81 557.19a0.624 0.624 0 0 1-0.431-1.077l4.843-4.607a0.625 0.625 0 1 1 0.861 0.9l-4.844 4.608a0.622 0.622 0 0 1-0.429 0.176z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  id: "path114",
  d: "m957.42 583.09a0.625 0.625 0 0 1-0.429-1.079l6.646-6.314a0.626 0.626 0 0 1 0.86 0.909l-6.645 6.312a0.63 0.63 0 0 1-0.432 0.172z"
});

var _ref18 = /*#__PURE__*/React.createElement("g", {
  id: "i2_5"
}, /*#__PURE__*/React.createElement("path", {
  id: "path108",
  d: "m971.72 634.96a70.684 70.684 0 1 1 70.681-70.683 70.763 70.763 0 0 1-70.681 70.683zm0-129.37a58.684 58.684 0 1 0 58.681 58.685 58.75 58.75 0 0 0-58.681-58.685z",
  fill: "#2d250c"
}), /*#__PURE__*/React.createElement("g", {
  id: "g940"
}, /*#__PURE__*/React.createElement("path", {
  id: "path112",
  d: "m958.81 557.19a0.621 0.621 0 0 1-0.521-0.279l-1.86-2.787a0.62515 0.62515 0 0 1 1.04-0.694l1.86 2.789a0.624 0.624 0 0 1-0.519 0.971z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path116",
  d: "m964.06 583.09a0.621 0.621 0 0 1-0.428-0.172l-6.646-6.312a0.62602 0.62602 0 0 1 0.861-0.909l6.645 6.314a0.626 0.626 0 0 1-0.432 1.079z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path118",
  d: "m996.48 599.81h-51.865a0.625 0.625 0 0 1-0.624-0.625v-65.107a0.624 0.624 0 0 1 0.624-0.625h14.993a0.623 0.623 0 0 1 0.624 0.625v7.232h20.63v-7.232a0.625 0.625 0 0 1 0.625-0.625h14.993a0.622 0.622 0 0 1 0.624 0.625v65.107a0.624 0.624 0 0 1-0.624 0.625zm-51.239-1.25h50.613v-63.86h-13.741v7.232a0.625 0.625 0 0 1-0.626 0.624h-21.879a0.625 0.625 0 0 1-0.626-0.624v-7.232h-13.741z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path120",
  d: "m992.48 594.79h-43.862a0.623 0.623 0 0 1-0.625-0.625v-55.062a0.623 0.623 0 0 1 0.625-0.624h10.991a0.623 0.623 0 0 1 0.624 0.624v2.211h20.63v-2.211a0.624 0.624 0 0 1 0.625-0.624h10.992a0.624 0.624 0 0 1 0.625 0.624v55.063a0.625 0.625 0 0 1-0.625 0.624zm-43.238-1.249h42.613v-53.813h-9.741v2.21a0.625 0.625 0 0 1-0.626 0.624h-21.879a0.625 0.625 0 0 1-0.626-0.624v-2.21h-9.741z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path122",
  d: "m967.46 560.37h-13.441a0.624 0.624 0 0 1-0.624-0.624v-11.574a0.626 0.626 0 0 1 0.624-0.625h13.441a0.625 0.625 0 0 1 0.625 0.625v11.574a0.624 0.624 0 0 1-0.625 0.624zm-12.814-1.25h12.188v-10.319h-12.188z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path124",
  d: "m968.36 586.49h-15.233a0.624 0.624 0 0 1-0.624-0.625v-13.117a0.624 0.624 0 0 1 0.624-0.625h15.233a0.625 0.625 0 0 1 0.625 0.625v13.117a0.625 0.625 0 0 1-0.625 0.625zm-14.608-1.25h13.982v-11.867h-13.982z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path126",
  d: "m987.97 551.26h-15.881a0.6255 0.6255 0 0 1 0-1.251h15.881a0.6255 0.6255 0 1 1 0 1.251z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path128",
  d: "m981.73 557.01h-9.643a0.625 0.625 0 0 1 0-1.25h9.643a0.625 0.625 0 0 1 0 1.25z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path130",
  d: "m987.97 577.5h-15.881a0.625 0.625 0 0 1 0-1.25h15.881a0.625 0.625 0 1 1 0 1.25z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path132",
  d: "m981.73 583.25h-9.643a0.625 0.625 0 0 1 0-1.25h9.643a0.625 0.625 0 0 1 0 1.25z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path134",
  d: "m981.49 542.56h-21.879a0.625 0.625 0 0 1-0.626-0.624v-10.206a0.625 0.625 0 0 1 0.626-0.625h5.767a5.245 5.245 0 0 1 10.345 0h5.767a0.624 0.624 0 0 1 0.626 0.625v10.206a0.625 0.625 0 0 1-0.626 0.624zm-21.255-1.249h20.63v-8.957h-5.7a0.624 0.624 0 0 1-0.624-0.591 4 4 0 0 0-7.98 0 0.624 0.624 0 0 1-0.623 0.591h-5.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path136",
  d: "m970.55 540.09a3.116 3.116 0 1 1 3.113-3.115 3.119 3.119 0 0 1-3.113 3.115zm0-4.981a1.865 1.865 0 1 0 1.863 1.866 1.869 1.869 0 0 0-1.863-1.866z"
})));

var _ref19 = /*#__PURE__*/React.createElement("path", {
  id: "path138",
  d: "m1173 379.19a74.385 74.385 0 1 1-74.385 74.387 74.384 74.384 0 0 1 74.385-74.387z",
  fill: "url(#g)",
  fillRule: "evenodd"
});

var _ref20 = /*#__PURE__*/React.createElement("g", {
  id: "i2_6"
}, /*#__PURE__*/React.createElement("path", {
  id: "path140",
  d: "m1173 524.26a70.684 70.684 0 1 1 70.681-70.683 70.764 70.764 0 0 1-70.681 70.683zm0-129.37a58.684 58.684 0 1 0 58.681 58.685 58.75 58.75 0 0 0-58.681-58.685z",
  fill: "#5d752e"
}), /*#__PURE__*/React.createElement("g", {
  id: "g970",
  fill: "#2d250c"
}, /*#__PURE__*/React.createElement("path", {
  id: "path142",
  d: "m1140.9 466.15a0.572 0.572 0 0 1-0.287-0.075 0.589 0.589 0 0 1-0.268-0.348l-3.892-14.55a0.574 0.574 0 0 1 0.406-0.7l5.978-1.6a0.576 0.576 0 0 1 0.434 0.058 0.584 0.584 0 0 1 0.268 0.347l3.894 14.551a0.571 0.571 0 0 1-0.4 0.7l-5.983 1.6a0.5 0.5 0 0 1-0.15 0.017zm-3.195-14.719 3.6 13.448 4.877-1.306-3.6-13.446z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path144",
  d: "m1177 463.9h-0.029l-30.508-0.773a0.568 0.568 0 0 1-0.537-0.423l-3.131-11.692a0.571 0.571 0 0 1 0.252-0.637l26.031-15.917a0.574 0.574 0 0 1 0.6 0 0.566 0.566 0 0 1 0.261 0.54 45.815 45.815 0 0 0 7.438 27.9 0.572 0.572 0 0 1-0.381 1zm-30.082-1.905 28.959 0.733a47.658 47.658 0 0 1-7.158-26.712l-24.71 15.109z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path146",
  d: "m1185.6 469.84c-5.523 0-12-8.6-15.053-20-3.4-12.663-1.505-23.807 4.317-25.368a5.292 5.292 0 0 1 1.359-0.177c5.537 0 12.006 8.6 15.051 20 3.4 12.664 1.506 23.808-4.305 25.371a5.322 5.322 0 0 1-1.369 0.174zm-9.377-44.4a4.066 4.066 0 0 0-1.06 0.139c-5.026 1.348-6.635 12.324-3.51 23.968 2.879 10.741 9.006 19.154 13.947 19.154a4.2 4.2 0 0 0 1.074-0.139c5.02-1.349 6.623-12.327 3.5-23.971-2.871-10.743-8.996-19.154-13.949-19.154z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path148",
  d: "m1189.5 467.88a0.546 0.546 0 0 1-0.2-0.036c-5.048-1.862-10.212-9.73-12.857-19.579s-2.1-19.25 1.348-23.4a0.57 0.57 0 0 1 0.634-0.17c5.047 1.858 10.217 9.732 12.856 19.591s2.1 19.257-1.344 23.386a0.563 0.563 0 0 1-0.437 0.208zm-11.082-41.955c-2.94 3.991-3.307 12.941-0.864 22.044s7.229 16.666 11.758 18.649c2.942-3.974 3.309-12.923 0.867-22.033s-7.232-16.679-11.761-18.66z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path150",
  d: "m1177.7 451.29a0.562 0.562 0 0 1-0.543-0.4c-0.308-0.968-0.564-1.825-0.775-2.624-0.232-0.85-0.437-1.724-0.639-2.664a0.579 0.579 0 0 1 0.327-0.637 12.737 12.737 0 0 1 2.107-0.753 13.04 13.04 0 0 1 3.328-0.466c2.3 0 3.871 0.756 4.215 2.021 0.26 0.971-0.254 2.049-1.445 3.032a11.664 11.664 0 0 1-4.309 2.085 14.314 14.314 0 0 1-2.213 0.4zm-0.738-5.468c0.164 0.751 0.334 1.457 0.526 2.148 0.173 0.66 0.376 1.356 0.619 2.128a14.185 14.185 0 0 0 1.564-0.317 10.469 10.469 0 0 0 3.875-1.863c0.815-0.668 1.2-1.345 1.067-1.849-0.192-0.707-1.438-1.179-3.108-1.179a11.886 11.886 0 0 0-3.037 0.429 11.719 11.719 0 0 0-1.506 0.503z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path152",
  d: "m1161.1 483.29a0.577 0.577 0 0 1-0.5-0.3l-11.071-20.072a0.573 0.573 0 0 1 0.02-0.582 0.586 0.586 0 0 1 0.51-0.267l6.791 0.341a0.568 0.568 0 0 1 0.468 0.292l9.7 17.422a0.576 0.576 0 0 1-0.276 0.8l-5.416 2.311a0.556 0.556 0 0 1-0.226 0.055zm-10.074-20.023 10.324 18.723 4.355-1.86-9.23-16.591z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path154",
  d: "m1149.8 455.98a0.571 0.571 0 0 1-0.144-1.123l17.908-4.806a0.572 0.572 0 1 1 0.293 1.1l-17.906 4.805a0.56 0.56 0 0 1-0.151 0.024z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path156",
  d: "m1198.1 441.69a0.571 0.571 0 0 1-0.15-1.122l5.92-1.585a0.574 0.574 0 0 1 0.7 0.407 0.566 0.566 0 0 1-0.406 0.7l-5.916 1.583a0.583 0.583 0 0 1-0.148 0.017z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path158",
  d: "m1205.4 448.96h-6.111a0.572 0.572 0 1 1 0-1.144h6.113a0.572 0.572 0 1 1 0 1.144z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path160",
  d: "m1204.5 457.88a0.519 0.519 0 0 1-0.145-0.019l-5.908-1.583a0.572 0.572 0 1 1 0.3-1.1l5.906 1.584a0.571 0.571 0 0 1-0.148 1.123z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path162",
  d: "m1190.3 429.31a0.573 0.573 0 0 1-0.4-0.977l4.328-4.326a0.571 0.571 0 0 1 0.809 0 0.582 0.582 0 0 1 0 0.809l-4.327 4.325a0.584 0.584 0 0 1-0.41 0.169z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path164",
  d: "m1195 434.99a0.571 0.571 0 0 1-0.283-1.068l5.3-3.057a0.57143 0.57143 0 0 1 0.571 0.99l-5.305 3.058a0.555 0.555 0 0 1-0.283 0.077z"
})));

var _ref21 = /*#__PURE__*/React.createElement("path", {
  id: "path166",
  d: "m1348.7 231.35a74.386 74.386 0 1 1-74.383 74.388 74.387 74.387 0 0 1 74.383-74.388z",
  fill: "url(#h)",
  fillRule: "evenodd"
});

var _ref22 = /*#__PURE__*/React.createElement("g", {
  id: "i2_7"
}, /*#__PURE__*/React.createElement("path", {
  id: "path168",
  d: "m1348.7 376.42a70.684 70.684 0 1 1 70.683-70.683 70.763 70.763 0 0 1-70.683 70.683zm0-129.37a58.684 58.684 0 1 0 58.683 58.685 58.75 58.75 0 0 0-58.683-58.685z",
  fill: "#f4c478"
}), /*#__PURE__*/React.createElement("g", {
  id: "g1040",
  fill: "#2d250c"
}, /*#__PURE__*/React.createElement("g", {
  id: "g1006"
}, /*#__PURE__*/React.createElement("path", {
  id: "path178",
  d: "m1363 322.4a6.315 6.315 0 1 1 6.322-6.311 6.321 6.321 0 0 1-6.322 6.311zm0-11.322a5.01 5.01 0 1 0 5.016 5.011 5.017 5.017 0 0 0-5.016-5.012z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path180",
  d: "m1359.2 316.43a6.274 6.274 0 0 1-2.036-0.337 0.65239 0.65239 0 1 1 0.421-1.235 5 5 0 0 0 1.615 0.264 4.947 4.947 0 0 0 4.012-2.007 0.657 0.657 0 0 1 0.931-0.122 5.136 5.136 0 0 0 4.218 1 0.659 0.659 0 0 1 0.77 0.51 0.649 0.649 0 0 1-0.506 0.769 6.458 6.458 0 0 1-4.775-0.884 6.343 6.343 0 0 1-4.65 2.042z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path182",
  d: "m1371.7 341.88a2.54 2.54 0 0 1-2.534-2.541v-2.274a0.652 0.652 0 0 1 1.3 0v2.274a1.233 1.233 0 0 0 1.229 1.235 1.306 1.306 0 0 0 1.241-1.28v-8.863a5.389 5.389 0 0 0-5.383-5.38h-8.719a5.385 5.385 0 0 0-5.379 5.38v8.924a1.222 1.222 0 0 0 1.224 1.219 1.235 1.235 0 0 0 1.237-1.235v-2.274a0.654 0.654 0 0 1 1.307 0v2.274a2.5375 2.5375 0 0 1-5.075 0.016v-8.924a6.7 6.7 0 0 1 6.686-6.687h8.719a6.7 6.7 0 0 1 6.689 6.687v8.924a2.609 2.609 0 0 1-2.542 2.525z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path184",
  d: "m1369.8 345.44h-13.251a0.652 0.652 0 0 1-0.651-0.653v-10.139a0.654 0.654 0 0 1 1.307 0v9.484h11.941v-9.484a0.652 0.652 0 1 1 1.3 0v10.139a0.652 0.652 0 0 1-0.646 0.653z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path186",
  d: "m1363.2 336.36a0.655 0.655 0 0 1-0.653-0.653v-7.775h-1.486a0.653 0.653 0 1 1 0-1.306h4.287a0.653 0.653 0 1 1 0 1.306h-1.494v7.775a0.654 0.654 0 0 1-0.654 0.653z"
})), /*#__PURE__*/React.createElement("g", {
  id: "g1013"
}, /*#__PURE__*/React.createElement("path", {
  id: "path170",
  d: "m1326 278.67a6.315 6.315 0 1 1 6.324-6.312 6.321 6.321 0 0 1-6.324 6.312zm0-11.324a5.009 5.009 0 1 0 5.018 5.012 5.017 5.017 0 0 0-5.018-5.012z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path172",
  d: "m1334.7 298.15a2.538 2.538 0 0 1-2.543-2.533v-2.277a0.655 0.655 0 1 1 1.309 0v2.277a1.248 1.248 0 0 0 1.234 1.231 1.315 1.315 0 0 0 1.238-1.282v-8.862a5.39 5.39 0 0 0-5.387-5.382h-8.714a5.389 5.389 0 0 0-5.385 5.382v8.925a1.227 1.227 0 0 0 1.235 1.219 1.249 1.249 0 0 0 1.235-1.231v-2.277a0.653 0.653 0 1 1 1.306 0v2.277a2.541 2.541 0 0 1-5.082 0.012v-8.929a6.7 6.7 0 0 1 6.691-6.686h8.714a6.7 6.7 0 0 1 6.694 6.686v8.925a2.6 2.6 0 0 1-2.545 2.525z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path174",
  d: "m1332.8 301.71h-13.241a0.652 0.652 0 0 1-0.653-0.652v-10.136a0.653 0.653 0 1 1 1.306 0v9.484h11.932v-9.484a0.655 0.655 0 0 1 1.309 0v10.136a0.651 0.651 0 0 1-0.653 0.652z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path176",
  d: "m1326.2 292.62a0.652 0.652 0 0 1-0.653-0.654v-7.771h-1.5a0.652 0.652 0 1 1 0-1.3h4.3a0.652 0.652 0 0 1 0 1.3h-1.5v7.774a0.652 0.652 0 0 1-0.647 0.651z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path194",
  d: "m1322.3 272.7a6.246 6.246 0 0 1-2.034-0.337 0.653 0.653 0 1 1 0.423-1.235 5 5 0 0 0 5.624-1.742 0.649 0.649 0 0 1 0.44-0.255 0.621 0.621 0 0 1 0.49 0.138 5.085 5.085 0 0 0 4.2 1 0.65129 0.65129 0 1 1 0.276 1.273 6.222 6.222 0 0 1-1.328 0.138 6.378 6.378 0 0 1-3.442-1.02 6.259 6.259 0 0 1-4.649 2.04z"
})), /*#__PURE__*/React.createElement("path", {
  id: "path196",
  d: "m1346.1 336.98h-20.792a0.652 0.652 0 0 1-0.655-0.653v-32.583a0.653 0.653 0 0 1 1.305 0v31.93h20.142a0.653 0.653 0 1 1 0 1.306z"
}), /*#__PURE__*/React.createElement("g", {
  id: "g999"
}, /*#__PURE__*/React.createElement("path", {
  id: "path188",
  d: "m1349.8 307.74a0.636 0.636 0 0 1-0.318-0.083 0.654 0.654 0 0 1-0.328-0.664l1.32-9h-5.818a0.65 0.65 0 0 1-0.651-0.652v-23.865a0.649 0.649 0 0 1 0.651-0.651h37.006a0.652 0.652 0 0 1 0.652 0.651v23.866a0.653 0.653 0 0 1-0.652 0.652h-20.022l-11.419 9.594a0.652 0.652 0 0 1-0.421 0.152zm-4.491-11.054h5.92a0.653 0.653 0 0 1 0.491 0.226 0.665 0.665 0 0 1 0.153 0.524l-1.178 8.048 10.291-8.643a0.647 0.647 0 0 1 0.42-0.155h19.6v-22.557h-35.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path190",
  d: "m1367.6 278.15h-16.313a0.652 0.652 0 1 1 0-1.3h16.309a0.651 0.651 0 1 1 0 1.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path192",
  d: "m1375.1 278.15h-4.1a0.652 0.652 0 1 1 0-1.3h4.1a0.651 0.651 0 1 1 0 1.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path198",
  d: "m1375.1 281.89h-16.317a0.6535 0.6535 0 0 1 0-1.307h16.317a0.6535 0.6535 0 0 1 0 1.307z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path200",
  d: "m1355.4 281.89h-4.1a0.6535 0.6535 0 1 1 0-1.307h4.1a0.6535 0.6535 0 0 1 0 1.307z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path202",
  d: "m1367.6 285.63h-16.313a0.653 0.653 0 1 1 0-1.306h16.309a0.653 0.653 0 1 1 0 1.306z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path204",
  d: "m1375.1 285.63h-4.1a0.653 0.653 0 1 1 0-1.306h4.1a0.653 0.653 0 0 1 0 1.306z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path206",
  d: "m1375.1 289.37h-16.317a0.6535 0.6535 0 0 1 0-1.307h16.317a0.6535 0.6535 0 0 1 0 1.307z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path208",
  d: "m1355.4 289.37h-4.1a0.6535 0.6535 0 1 1 0-1.307h4.1a0.6535 0.6535 0 0 1 0 1.307z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path210",
  d: "m1367.6 293.1h-16.313a0.6535 0.6535 0 1 1 0-1.307h16.309a0.6535 0.6535 0 1 1 0 1.307z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path212",
  d: "m1375.1 293.1h-4.1a0.6535 0.6535 0 1 1 0-1.307h4.1a0.6535 0.6535 0 0 1 0 1.307z"
}))));

var _ref23 = /*#__PURE__*/React.createElement("g", {
  fill: "#2d250c"
}, /*#__PURE__*/React.createElement("path", {
  id: "path214",
  d: "m144.88 500.83a0.615 0.615 0 0 1 0.011-1.173 114.47 114.47 0 0 1 123.46 38.424 0.615 0.615 0 0 1-0.1 0.864 0.624 0.624 0 0 1-0.867-0.1 113.24 113.24 0 0 0-122.13-38.01 0.608 0.608 0 0 1-0.374-0.01z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path216",
  d: "m269.66 535.9 0.883 6.08-5.707-2.276z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path218",
  d: "m348.31 561.29a0.615 0.615 0 0 1-0.259-1.144 114.48 114.48 0 0 1 129 8.846 0.616 0.616 0 0 1 0.1 0.866 0.622 0.622 0 0 1-0.865 0.1 113.24 113.24 0 0 0-127.61-8.751 0.6 0.6 0 0 1-0.365 0.083z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path220",
  d: "m477.82 566.56 2.265 5.712-6.08-0.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path222",
  d: "m560.84 572.69a0.615 0.615 0 0 1-0.463-1.078 114.48 114.48 0 0 1 128.46-14.761 0.611 0.611 0 0 1 0.255 0.831 0.62 0.62 0 0 1-0.832 0.258 113.24 113.24 0 0 0-127.08 14.6 0.582 0.582 0 0 1-0.343 0.15z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path224",
  d: "m689.15 554.33 3.266 5.2-6.141 0.225z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path226",
  d: "m771 539.54a0.615 0.615 0 0 1-0.647-0.977 114.47 114.47 0 0 1 123.79-37.368 0.611 0.611 0 0 1 0.4 0.774 0.623 0.623 0 0 1-0.775 0.4 113.24 113.24 0 0 0-122.45 36.964 0.578 0.578 0 0 1-0.312 0.207z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path228",
  d: "m894 498.66 4.142 4.541-6 1.313z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path230",
  d: "m970.13 468a0.614 0.614 0 0 1-0.835-0.82 114.47 114.47 0 0 1 113.35-62.223 0.611 0.611 0 0 1 0.55 0.674 0.625 0.625 0 0 1-0.674 0.555 113.23 113.23 0 0 0-112.13 61.549 0.578 0.578 0 0 1-0.261 0.265z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path232",
  d: "m1082 402.5 4.991 3.583-5.6 2.53z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path234",
  d: "m1153.1 355.52a0.614 0.614 0 0 1-0.946-0.689 114.47 114.47 0 0 1 103-78.173 0.61 0.61 0 0 1 0.643 0.586 0.621 0.621 0 0 1-0.584 0.647 113.24 113.24 0 0 0-101.89 77.33 0.581 0.581 0 0 1-0.224 0.299z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path236",
  d: "m1254.1 274.33 5.463 2.813-5.17 3.324z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path238",
  d: "m1310.7 213.99a0.609 0.609 0 0 1-0.533 0.184 0.619 0.619 0 0 1-0.522-0.7 114.47 114.47 0 0 1 87.635-95.079 0.611 0.611 0 0 1 0.736 0.462 0.623 0.623 0 0 1-0.463 0.741 113.24 113.24 0 0 0-86.689 94.055 0.6 0.6 0 0 1-0.164 0.337z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path240",
  d: "m1395.9 116.28 5.875 1.807-4.506 4.184z"
}), /*#__PURE__*/React.createElement("g", {
  fontFamily: "Lato-Bold, Lato",
  fontWeight: 700
}, /*#__PURE__*/React.createElement("text", {
  id: "text248",
  x: 45.087002,
  y: 435.83099,
  fontSize: "18px"
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan242",
  x: 45.087002,
  y: 435.83099
}, "Teavita meid"), /*#__PURE__*/React.createElement("tspan", {
  id: "tspan246",
  fontFamily: "Lato-Light, Lato",
  fontWeight: 300
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan244",
  x: 45.087002,
  y: 457.431
}, "m\xFC\xFCgisoovist"))), /*#__PURE__*/React.createElement("text", {
  id: "text252",
  x: 0.64999998,
  y: 456.599,
  fontSize: "48px"
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan250",
  x: 0.64999998,
  y: 456.599
}, "1.")), /*#__PURE__*/React.createElement("text", {
  id: "text260",
  x: 303.86499,
  y: 477.79501,
  fontSize: "18px"
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan254",
  x: 303.86499,
  y: 477.79501
}, "Tutvume"), /*#__PURE__*/React.createElement("tspan", {
  id: "tspan258",
  fontFamily: "Lato-Light, Lato",
  fontWeight: 300
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan256",
  x: 303.86499,
  y: 499.39499
}, "objektiga"))), /*#__PURE__*/React.createElement("text", {
  id: "text264",
  x: 260.741,
  y: 498.66,
  fontSize: "48px"
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan262",
  x: 260.741,
  y: 498.66
}, "2.")), /*#__PURE__*/React.createElement("text", {
  id: "text272",
  x: 505.12299,
  y: 501.117,
  fontSize: "18px"
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan266",
  x: 505.12299,
  y: 501.117
}, "S\xF5lmime"), /*#__PURE__*/React.createElement("tspan", {
  id: "tspan270",
  fontFamily: "Lato-Light, Lato",
  fontWeight: 300
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan268",
  x: 505.12299,
  y: 522.71698
}, "lepingud"))), /*#__PURE__*/React.createElement("text", {
  id: "text276",
  x: 462.57001,
  y: 522.771,
  fontSize: "48px"
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan274",
  x: 462.57001,
  y: 522.771
}, "3.")), /*#__PURE__*/React.createElement("text", {
  id: "text284",
  x: 668.53601,
  y: 489.229,
  fontSize: "18px"
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan278",
  x: 668.53601,
  y: 489.229
}, "Aitame esitada"), /*#__PURE__*/React.createElement("tspan", {
  id: "tspan282",
  fontFamily: "Lato-Light, Lato",
  fontWeight: 300
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan280",
  x: 668.53601,
  y: 510.82901
}, "metsateatised"))), /*#__PURE__*/React.createElement("text", {
  id: "text288",
  x: 625.41302,
  y: 509.944,
  fontSize: "48px"
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan286",
  x: 625.41302,
  y: 509.944
}, "4.")), /*#__PURE__*/React.createElement("text", {
  id: "text296",
  x: 848.60797,
  y: 435.83099,
  fontSize: "18px"
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan290",
  x: 848.60797,
  y: 435.83099
}, "Kontrollime \xFCle"), /*#__PURE__*/React.createElement("tspan", {
  id: "tspan294",
  fontFamily: "Lato-Light, Lato",
  fontWeight: 300
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan292",
  x: 848.60797,
  y: 457.431
}, "andmed"))), /*#__PURE__*/React.createElement("text", {
  id: "text300",
  x: 805.65002,
  y: 456.716,
  fontSize: "48px"
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan298",
  x: 805.65002,
  y: 456.716
}, "5.")), /*#__PURE__*/React.createElement("text", {
  id: "text308",
  x: 1036.826,
  y: 333.79401,
  fontSize: "18px"
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan302",
  x: 1036.826,
  y: 333.79401
}, "Teavitame"), /*#__PURE__*/React.createElement("tspan", {
  id: "tspan306",
  fontFamily: "Lato-Light, Lato",
  fontWeight: 300
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan304",
  x: 1036.826,
  y: 355.39401
}, "ostjaid"))), /*#__PURE__*/React.createElement("text", {
  id: "text312",
  x: 993.104,
  y: 355.086,
  fontSize: "48px"
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan310",
  x: 993.104,
  y: 355.086
}, "6.")), /*#__PURE__*/React.createElement("text", {
  id: "text320",
  x: 1185.516,
  y: 206.425,
  fontSize: "18px"
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan314",
  x: 1185.516,
  y: 206.425
}, "Hoiame Sind"), /*#__PURE__*/React.createElement("tspan", {
  id: "tspan318",
  fontFamily: "Lato-Light, Lato",
  fontWeight: 300
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan316",
  x: 1185.516,
  y: 228.02499
}, "kursis"))), /*#__PURE__*/React.createElement("text", {
  id: "text326",
  x: 1147.417,
  y: 227.938,
  fontSize: "48px"
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan322",
  x: 1147.417,
  y: 227.938,
  letterSpacing: "-.15em"
}, "7"), /*#__PURE__*/React.createElement("tspan", {
  id: "tspan324",
  y: 227.938
}, ".")), /*#__PURE__*/React.createElement("text", {
  id: "text334",
  x: 1309.6479,
  y: 61.890999,
  fontSize: "18px"
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan328",
  x: 1309.6479,
  y: 61.890999
}, "Aitame lepingu"), /*#__PURE__*/React.createElement("tspan", {
  id: "tspan332",
  fontFamily: "Lato-Light, Lato",
  fontWeight: 300
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan330",
  x: 1309.6479,
  y: 83.490997
}, "vormistamisel"))), /*#__PURE__*/React.createElement("text", {
  id: "text338",
  x: 1266.212,
  y: 83.403999,
  fontSize: "48px"
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan336",
  x: 1266.212,
  y: 83.403999
}, "8."))));

var SvgIllustration22 = function SvgIllustration22(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg344",
    width: 1566.7,
    height: 800,
    viewBox: "0 0 1566.7 800",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIllustration22, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/illustration2_2.6d52e404.svg";
export { ForwardRef as ReactComponent };